/**
 * Offline audience list for the Focus Group chat picker (AskNaturalOrganicChat).
 *
 * It names clients, so only an admin ever sees it, and only when `GET /healthcare-chat-v2/segments`
 * could not be asked. When the server answers, its answer is the whole list, even an empty one.
 *
 * Lives here rather than inside the component so it can be checked against
 * STARTER_QUESTIONS in a test — every selectable audience must have its own prompt chips.
 * The icon is added at the render site (it is a constant on this surface).
 */
import { SEGMENT_IDS } from './segments';

export type ChatSegmentOption = {
  id: number;
  name: string;
  adminOnly?: boolean;
};

export const CHAT_SEGMENTS: ChatSegmentOption[] = [
  { id: SEGMENT_IDS.NATURAL_ORGANIC, name: 'Natural Organic Shoppers' },
  { id: SEGMENT_IDS.FLAVCITY, name: 'FlavCity Protein Consumers' },
  { id: SEGMENT_IDS.KNF_SURVEY, name: 'Kettle & Fire Survey', adminOnly: true },
  { id: SEGMENT_IDS.DOGS_AUDIENCE, name: 'Dog Owners (Full)', adminOnly: true },
  { id: SEGMENT_IDS.CATS_AUDIENCE, name: 'Cat Owners (Full)', adminOnly: true },
  { id: SEGMENT_IDS.JERKY, name: 'Jerky & Meat-Snack Consumers Deep Survey', adminOnly: true },
  // Remote (stash) customer segments, admin-visible in the default dropdown
  { id: SEGMENT_IDS.SMARTYPANTS, name: 'SmartyPants Consumers', adminOnly: true },
  { id: SEGMENT_IDS.ALT_MILK, name: 'Alt Milk Consumers', adminOnly: true },
  { id: SEGMENT_IDS.AMY_AUDIENCE, name: "Amy's Kitchen Deep Survey Consumers", adminOnly: true },
  { id: SEGMENT_IDS.MONDELEZ, name: 'Cookie Consumers (Mondelez)', adminOnly: true },
  { id: SEGMENT_IDS.BREAKFAST_YOGURT, name: 'Breakfast - Yogurt', adminOnly: true },
  { id: SEGMENT_IDS.CHOCOLATE, name: 'Chocolate, Cookie & Cracker Consumers', adminOnly: true },
  { id: SEGMENT_IDS.FRESHPET_DOGS, name: 'Freshpet Dog Owners', adminOnly: true },
];
